import {
  BookOpen,
  Compass,
  MessagesSquare,
  GraduationCap,
  Languages,
  FileText,
  Video,
  Newspaper,
  Library,
  FlaskConical,
  Presentation,
  Mic,
} from "lucide-react";

export const ICON_MAP = {
  BookOpen,
  Compass,
  MessagesSquare,
  GraduationCap,
  Languages,
  FileText,
  Video,
  Newspaper,
  Library,
  FlaskConical,
  Presentation,
  Mic,
};

export const CATEGORIES = [
  { slug: "quranic-studies", path: "/quranic-studies", name: "Quranic Studies", group: "Programs", icon: "BookOpen",
    tagline: "Structured Quranic learning with qualified instructors and a global scholarly community." },
  { slug: "career-planning", path: "/services/career-planning", name: "Career Planning", group: "Services", icon: "Compass",
    tagline: "Self-assessments, curated career guides, and recommendations that point you to the right path." },
  { slug: "educational-consultation", path: "/services/educational-consultation", name: "Educational Consultation", group: "Services", icon: "MessagesSquare",
    tagline: "A direct line to education experts — ask anything, get answers within 24 hours." },
  { slug: "admission-guidance", path: "/services/admission-guidance", name: "Admission & Career Guidance", group: "Services", icon: "GraduationCap",
    tagline: "Admissions strategy by country, field, and level — scholarships and study visas included." },
  { slug: "visa-support", path: "/services/visa-support", name: "Language & Visa Support", group: "Services", icon: "Languages",
    tagline: "IELTS & TOEFL preparation, citizenship guidance, and end-to-end visa application support." },
  { slug: "online-tutoring", path: "/services/online-tutoring", name: "Online Tutoring", group: "Services", icon: "Video",
    tagline: "Book one-on-one sessions with vetted tutors, with secure links and session feedback." },
  { slug: "ielts-courses", path: "/ielts-courses", name: "IELTS Courses", group: "Services", icon: "Languages",
    tagline: "Six structured modules covering every section of the IELTS Academic test — taught by a specialist trainer." },
  { slug: "toefl-courses", path: "/toefl-courses", name: "TOEFL Courses", group: "Services", icon: "Languages",
    tagline: "Six targeted TOEFL iBT modules covering all four test sections plus Grammar and Pronunciation." },
  { slug: "english-language-courses", path: "/english-language-courses", name: "English Language Courses", group: "Services", icon: "Languages",
    tagline: "Six comprehensive modules building confident, accurate English across every core language skill." },
  { slug: "english-literature-courses", path: "/english-literature-courses", name: "English Literature Courses", group: "Services", icon: "BookOpen",
    tagline: "GCSE, A-Level, and university modules across literary forms, genres, and periods." },
  { slug: "ai-digital-literature-courses", path: "/ai-digital-literature-courses", name: "AI and Digital Turn in Literature", group: "Services", icon: "FlaskConical",
    tagline: "Use AI tools in literary teaching and research, and study how AI is changing literature." },
  { slug: "blogs", path: "/blogs", name: "Blogs", group: "Resources", icon: "Newspaper",
    tagline: "Guides and insights on admissions, careers, language tests, and studying abroad." },
  { slug: "resource-hub", path: "/resource-hub", name: "Resource Hub", group: "Resources", icon: "Library",
    tagline: "A curated library of books and materials, organized by category and author." },
  { slug: "research-papers", path: "/research-papers", name: "Research Papers", group: "Resources", icon: "FlaskConical",
    tagline: "Scholarly articles and research publications, browsable and downloadable." },
  { slug: "training", path: "/training", name: "Training", group: "Programs", icon: "Presentation",
    tagline: "Scheduled training sessions with materials, recordings, and completion certificates." },
  { slug: "interview-prep", path: "/interview-prep", name: "Interview Preparation", group: "Programs", icon: "Mic",
    tagline: "Mock interviews, question libraries, and one-on-one coaching that builds real confidence." },
];

export const SERVICE_CATEGORIES = CATEGORIES.filter((c) => c.group === "Services");
export const RESOURCE_CATEGORIES = CATEGORIES.filter((c) => c.group === "Resources");
export const PROGRAM_CATEGORIES = CATEGORIES.filter((c) => c.group === "Programs");

export const categoryBySlug = (slug) => CATEGORIES.find((c) => c.slug === slug);
